import type { Faq } from '../types/product';

export const faqs: Faq[] = [
  {
    q: 'What do I receive?',
    a: 'The English digital edition includes three 50-page volumes and five 30-page bonuses: 300 pages in total, delivered as PDF materials.',
  },
  {
    q: 'Is this a physical spiral-bound book?',
    a: 'No. This is a digital product. Spiral-bound booklets and loose worksheets in the images are visual mockups. No physical item will be mailed.',
  },
  {
    q: 'How do I access the files?',
    a: 'After payment is confirmed, access instructions are sent to the email address entered at checkout. If they do not arrive, check your spam or promotions folder and contact support.',
  },
  {
    q: 'Do I need to print the materials?',
    a: 'No. The PDFs can be read on a phone, tablet, or computer. You can print individual pages for your own use if that is more convenient.',
  },
  {
    q: 'Does Volume II provide exact treatment recipes or dosage instructions?',
    a: 'No. Volume II contains proposed educational formula studies within the traditional Bach Flower framework. It does not provide dosage, preparation instructions, treatment regimens, or individualized recommendations.',
  },
  {
    q: 'Is the Emergency Visual Plate an emergency or crisis protocol?',
    a: 'No. It is a visual reminder to pause, clarify professional boundaries, and connect with suitable local support. It does not provide clinical triage, risk assessment, emergency response, or crisis treatment. In an urgent situation, contact qualified local or emergency services.',
  },
  {
    q: 'Does this guide replace healthcare, formal training, or supervision?',
    a: 'No. It is an educational and practice-organization resource. It does not replace qualified healthcare, formal education, supervision, or requirements that apply to your location and professional role.',
  },
  {
    q: 'What is the refund policy?',
    a: 'You may request a refund within 7 calendar days of purchase by contacting support and following the published Refund Policy. The policy does not limit non-excludable statutory rights.',
  },
  {
    q: 'What currency will I pay in?',
    a: 'The displayed price is US$19 USD. Your bank or payment provider may convert it to your local currency and may apply its own fees.',
  },
  {
    q: 'Can I share the PDFs with colleagues?',
    a: 'The purchase is for the purchaser’s personal use. Please do not copy, redistribute, resell, or share the files without written permission.',
  },
];
